import React,{useEffect,useState} from 'react'
import contactEditIcon from '../../../assets/images/contact-edit-icon.svg';
import contactDeleteIcon from '../../../assets/images/contact-delete-icon.svg';
import sliderCloseIcon from '../../../assets/images/slider-close-icon.svg';
import deletePopupIcon from '../../../assets/images/delete-popup-icon.svg';
import {useSelector,useDispatch} from 'react-redux'
import { fetchCustomMessages,deleteCustomMessage,updatecustomMessage } from '../../../redux/action';
import moment from 'moment-timezone'
import { apiCall } from '../../../functions/utils';
import sampleImage from '../../../assets/images/sample.png'
import { Colxx } from '../../../components/shared/CustomBootstrap';

import {
    Col,
    Row,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Collapse,
    Input,
    Label,
    InputGroup,
    CustomInput,
    InputGroupAddon,
  
      Card,
      FormGroup
  } from "reactstrap";
export default function Reminders() {
    const dispatch=useDispatch()
   const custommessages=useSelector((state)=>state.customMessages)
   const [accordion,setAccordian]=useState([false])
   const [selectedReminder,setSelectedReminder]=useState({
    id : false,
    name: "",
    text_message: "",
    interval: 0,
    offset: 0,
    start_time: "",
    weekend_skip: 0,
    message_type: 1
   })

   const [selectedFile,setSelectedFile]=useState(false)
   const [reminderId,setReminderId]=useState({ value: "", label: " " })

   
   const onreminder_idChange = e => {
    console.log(e.target.value)
    setReminderId(e.target.value);
  }

   const fileCapture = event => {
    console.log(event.target.files[0])
    setSelectedFile(event.target.files[0])
   }

   const getCustomMessages=()=>{
    dispatch(fetchCustomMessages())
   }

   const toggleAccordion = tab => {
    const prevState = accordion;
    const state = prevState.map((x, index) => (tab === index ? !x : false));
    setAccordian(state);
  };

   const handleSubmit=()=>{
    console.log(selectedReminder)
    let form = new FormData()
    form.append('text_message', selectedReminder.text_message) 
    form.append('name', selectedReminder.name) 
    form.append('voice_message', "") 
    form.append('binary_files', "")
    form.append('message_type', selectedReminder.message_type)
    form.append('forward_type', 3)
    form.append('forward_date_time', null)
    form.append('is_active', 1)
    form.append('offset', selectedReminder.offset)
    form.append('interval', selectedReminder.interval)
    form.append('weekend_skip', selectedReminder.weekend_skip)
    form.append('message_type', selectedReminder.message_type)
    if( selectedReminder.start_time ){
      let utcTime = moment( selectedReminder.start_time, ['h:m a', 'H:m'] ).utc()
      form.append('start_time', utcTime.format('HH:mm:ss') )
    }

    if(selectedReminder.id)
    dispatch(updatecustomMessage(form,selectedReminder.id))
    else
    dispatch(updatecustomMessage(form))



   }

  const updateTextInput=( target )=>{
    let current=selectedReminder;
    if( target.type == "checkbox" ){
      current[ target.name ] = (current[ target.name ] == 0 ? 1:0)
    }else{
      current[ target.name ] = target.value
    } 
    setSelectedReminder({...current})
  }

   const clearState=()=>{
    setSelectedReminder({
        id : false,
    name: "",
    text_message: "",
    interval: 0,
    offset: 0,
    start_time: "",
    weekend_skip: 0,
    message_type: 1
    })
   }

   useEffect(()=>{
    getCustomMessages()
   },[])

   const handleUpload=async()=>{
    if(reminderId && selectedFile){
    var form = new FormData()
        // form.append('contact_id',contactId)
      form.append('timezone', moment.tz.guess() )
      form.append('reminder_id', reminderId )
      form.append('file', selectedFile )

      const response = await apiCall(true, "POST", `/api/reminders/bulk-store`, form)
      if( response && response.data && response.data.message == "Success"  ){
        alert(response.data.message+ ": " +response.data.success_count+ " successfull, " +response.data.error_count+ " failed" );
        window.location.href = '/app/upcoming-reminders';
      }else{
        alert(response.data.message, response.data.error );
      }
      console.log("CSV Upload success", response);
   }
   }
    return (
    <>
    <div class="row mt-4">
    <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 main-section-scroll-height">
        <div class="row pt-1">
            <div class="col-md-6 col-lg-6 col-sm-12 co-xs-12">
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12 co-xs-12">
                <div class="d-flex justify-content-end align-items-center">
                    <button class="secondary-btn me-2" type="button" data-bs-toggle="offcanvas"
                        data-bs-target="#createContactCanvas" aria-controls="createContactCanvas" onClick={clearState}>
                        Add New
                    </button>
                    <button class="primary-btn me-2">
                        See All Upcoming Reminders

                    </button>
                    <button class="primary-btn upload-csv" data-bs-toggle="offcanvas"
                        data-bs-target="#uploadCSVCanvas" aria-controls="uploadCSVCanvas">
                        Upload CSV

                    </button>


                </div>
            </div>
        </div>

        <table class="mt-2 table table-borderless">
            <thead>
                <tr>
                  {/*  <th class="align-middle" style={{width:'10%'}} scope="col">ID</th>*/}
                    <th class="align-middle" style={{width:'20%'}} scope="col">Reminder</th>
                    <th class="align-middle" style={{width:'60%'}} scope="col">Message</th>
                    <th class="align-middle" style={{width:'10%'}} scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
               
             {custommessages.reminders && custommessages.reminders.all && custommessages.reminders.all.length>0 && custommessages.reminders.all.map((reminder)=>(
              <tr key={reminder.id}>
              {/* <td class="align-middle"> ID#002</td>*/}
               <td class="align-middle">{reminder.name}</td>

               <td class="align-middle">{reminder.text_message}</td>
               <td class="align-middle">
                   <button class="slider-close-btn me-1" type="button" data-bs-toggle="offcanvas"
                       data-bs-target="#editContactCanvas" aria-controls="editContactCanvas" onClick={()=>setSelectedReminder(reminder)}>
                       <img src={contactEditIcon} class="img-fluid"/>
                   </button>
                   <button class="slider-close-btn me-1" data-bs-toggle="modal"
                       data-bs-target="#delteContact"><img
                           src={contactDeleteIcon} class="img-fluid" onClick={()=>setSelectedReminder(reminder)}/></button>
               </td>
           </tr>
             ))}
                
            </tbody>
        </table>
    </div>

</div> 
{/*<!--Create Contact Slider-->*/}
    <div class="offcanvas offcanvas-end" tabIndex="-1" id="createContactCanvas"
        aria-labelledby="createContactCanvasLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="createContactCanvasLabel">Add New Reminder</h5>
            <button type="button" class="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} class="img-fluid"/></button>
        </div>
        <div class="offcanvas-body">

            <div class="mt-2">
                <input type="text"  onChange = {e => { updateTextInput(e.target) }} name="name" value={selectedReminder.name} class="form-control slider-inputs" placeholder="Title"/>
            </div>
            <div class="mt-2">
                <textarea  onChange = {e => { updateTextInput(e.target) }} name="text_message" value={selectedReminder.text_message} class="form-control slider-inputs text-area-height" placeholder="Message Body"
                    aria-label="With textarea"></textarea>
            </div>

            <select value={selectedReminder.message_type} name="reminder_type"  onChange = {e => { updateTextInput(e.target) }}   class="form-select slider-inputs" aria-label="Default select example">
               <option value="">Reminder Type</option>
                <option value="1">Unscheduled</option>
                <option value="2">Scheduled</option>
            </select>

            <div class="mt-4">
                <p>After this reminder has been scheduled on a customer's account, Please specify offset interval before
                    the scheduled time?</p>
            </div>
            <div class="row mt-2">
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <input name="offset"  onChange = {e => { updateTextInput(e.target) }} type="text" value={selectedReminder.offset} class="form-control slider-inputs" placeholder="Offset"/>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <select value={selectedReminder.interval} name='interval'  onChange = {e => { updateTextInput(e.target) }} class="form-select slider-inputs" aria-label="Default select example">
                        <option value={0}>Hours</option>
                        <option value={1} >Days</option>
                        <option value={2}>Weeks</option>
                        <option value={3}>Months</option>
                    </select>
                </div>
            </div>
            <div class="form-check mt-4">
                <input  onChange = {e => { updateTextInput(e.target) }} name="weekend_skip" class="form-check-input" type="checkbox"  id="flexCheckDefault"/>
                <label class="form-check-label" for="flexCheckDefault">
                    Check this box if you would like to schedule the reminder to the next working day if the date falls
                    on a weekend?
                </label>
            </div>
            <div class="d-flex justify-content-end mt-4">
                <button class="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button class="slider-success-btn" onClick={handleSubmit}>Add</button>
            </div>
        </div>
    </div>


    {/*<!--Edit Contact Slider-->*/}
    <div class="offcanvas offcanvas-end" tabIndex="-1" id="editContactCanvas" aria-labelledby="editContactCanvasLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="editContactCanvasLabel">Update Reminder</h5>
            <button type="button" class="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} class="img-fluid"/></button>
        </div>
        <div class="offcanvas-body">

            <div class="mt-2">
                <input type="text" name="name" onChange = {e => { updateTextInput(e.target) }} class="form-control slider-inputs" placeholder="title"
                    value={selectedReminder.name}/>
            </div>
            <div class="mt-5">
                <textarea name="text_message" onChange = {e => {updateTextInput(e.target) }} class="form-control slider-inputs text-area-height" placeholder="Message Body"
                    aria-label="With textarea" value={selectedReminder.text_message}></textarea>
            </div>

            <select value={selectedReminder.message_type} name="message_type" onChange = {e => { updateTextInput(e.target) }} class="form-select slider-inputs" aria-label="Default select example">
                <option value="">Reminder Type</option>
                <option  value="1">Unscheduled</option>
                <option  value="2">Scheduled</option>
            </select>

            <div class="mt-4">
                <p>After this reminder has been scheduled on a customer's account, Please specify offset interval before
                    the scheduled time?</p>
            </div>
            <div class="row mt-2">
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <input onChange = {e => { updateTextInput(e.target) }} name="offset" type="number" class="form-control slider-inputs" placeholder="Offset" value={selectedReminder.offset}/>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <select value={selectedReminder.interval} name="interval" onChange = {e => { updateTextInput(e.target) }} class="form-select slider-inputs" aria-label="Default select example">
                        <option value={0}>Hours</option>
                        <option value={1} >Days</option>
                        <option value={2}>Weeks</option>
                        <option  value={3}>Months</option>
                    </select>
                </div>
            </div>

            <div class="d-flex justify-content-end mt-4">
                <button class="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button class="slider-success-btn" data-bs-dismiss="offcanvas" onClick={handleSubmit}>Update</button>
            </div>
        </div>
    </div>


   {/* <!--Delete Contact Popup--> */}
    <div class="modal fade" id="delteContact" tabIndex="-1" aria-labelledby="delteContactLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="delteContactLabel">Delete Record</h5>
                    <button type="button" class="slider-close-btn" data-bs-dismiss="modal">
                        <img src={sliderCloseIcon} class="img-fluid"/>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="d-flex justify-content-center">
                        <img src={deletePopupIcon}/>
                    </div>
                    <div class="mt-4">
                        <p class="text-center">Do you really want to remove this record?</p>
                    </div>
                </div>
                <div class="d-flex justify-content-center mb-4">
                    <button class="slider-cancel-btn me-2" data-bs-dismiss="modal">Cancel</button>
                    <button class="slider-success-btn" data-bs-dismiss="modal" onClick={()=>dispatch(deleteCustomMessage(selectedReminder.id))}>Remove</button>
                </div>
            </div>
        </div>
    </div>



{/*    <!--Upload CSV Slider--> */}
    <div class="offcanvas offcanvas-end" tabIndex="-1" id="uploadCSVCanvas" aria-labelledby="uploadCSVCanvasLabel">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="uploadCSVCanvasLabel">Upload CSV</h5>
            <button type="button" class="slider-close-btn" data-bs-dismiss="offcanvas"><img
                    src={sliderCloseIcon} class="img-fluid"/></button>
        </div>
        <div class="offcanvas-body">


        {/*test */}
        <div >
                  <Button
                    color="link"
                   onClick={() => toggleAccordion(0)}
                   aria-expanded={accordion[0]}
                  >
                    How to use this feature?
                  </Button>
                  <Collapse isOpen={accordion[0]}>
                    <Colxx xxs="12"   className="mb-3">
                      <Card style={{padding:10, width:'100%'}} className="d-flex">
                        <p>
                          To successfully upload a CSV file, please make sure that the first row in your file has column headings that look exactly like the column headings in the sample link or image below. It is not important if the headings are in the same order as is shown here, but for the software to recognize the data in your spreadsheet your CSV file must have the columns named as they are in the image below.
                        </p>
                        <p>
                          If you are uploading a CSV file for a reminder for past services and are only going to use "Date of last service", then you do not need to worry about having columns for "Date of appointment" and "Time of appointment" and vice versa.
                        </p>
                        <p>
                        If you would like a reminder to be recurring (meaning that if your reminder is a 6 month reminder it will repeatedly send the reminder to your contact every 6 months) then please include a column in your CSV file titled "Recurring". Put a "Y" or "yes" to mark each contact that you would like to mark as recurring.
                        </p>
                        {/* <a color="link" target="_blank" href="https://docs.google.com/spreadsheets/d/1ihXenfRuayXUJ-IS6W9S0lUipwPNiKn8MEyEdQR89W8/edit?usp=sharing"></a> */}
                        <Button
                          color="link"
                          onClick={() => window.open("https://docs.google.com/spreadsheets/d/1ihXenfRuayXUJ-IS6W9S0lUipwPNiKn8MEyEdQR89W8/edit?usp=sharing", "_blank")}
                          // aria-expanded={this.state.accordion[0]}
                        >
                          Sample file
                        </Button>
                       
                        <img onClick={() => window.open("/assets/img/sample.png", "_blank")} height="85rem" src={sampleImage} />
                      </Card>
                    </Colxx>
                  </Collapse>
                </div>

        {/* test */}





           



            <div class="slider-inputs text-area-height d-flex flex-column justify-content-center align-items-center">
                <div class="mb-3">
                    <label for="formFile" class="form-label d-flex flex-column align-items-center"><i
                            class="fa-solid fa-file-arrow-up mb-2 upload-icon"></i><span>Upload or Browse
                            File</span></label>
                    <input class="form-control d-none" onChange={fileCapture} type="file" name="customFile" id="formFile"/>
                </div>
            </div>
            <select class="form-select slider-inputs mt-4" name="reminder_id" value={reminderId} onChange={onreminder_idChange}  aria-label="Default select example">
                <option value="">Choose Reminder</option>
                {custommessages && custommessages.reminders && custommessages.reminders.all && custommessages.reminders.all.map((reminder)=>(
                <option key={reminder.id} value={reminder.id}>{reminder.name}</option>
               
                ))}

            </select>



            <div class="d-flex justify-content-end mt-4">
                <button class="slider-cancel-btn me-2" data-bs-dismiss="offcanvas">Cancel</button>
                <button class="slider-success-btn" onClick={handleUpload}>Upload</button>
            </div>
        </div>
    </div>


</> )
}
